export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGOUT = 'LOGOUT';

export const loginSuccess = (token) => {
  return {
    type: LOGIN_SUCCESS,
    payload: {
      isLoggedIn: true,
      token: token
    }
  };
}

export const loginFailure = (err) => {
  return {
    type: LOGIN_FAILURE,
    payload: {
      isLoggedIn: false,
      token: null,
      error: err
    }
  };
}

export const logout = () => {
  return {
    type: LOGOUT,
    payload: {
      isLoggedIn: false,
      token: null,
      error: null
    }
  };
}